// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"b51ca53b","155":"82764e18","383":"4a152d49","392":"5582fe7d","840":"a6e25632","976":"a4ddf130"}[chunkId] + ".chunk.css";
};